<script lang="ts" setup>
type Props = {
  content: string
}

defineProps<Props>()

const { path } = useRoute()
</script>

<template>
  <nuxt-link class="sales__factoid" :to="{ path: path }" :prefetch="false">
    <div class="sales__factoid-content">
      <div class="addition-info__content" v-html="content" />
    </div>
  </nuxt-link>
</template>

<style lang="scss" scoped>
.sales__factoid {
  max-width: 376px;
  padding: 36px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ui-text-primary);
  cursor: default;
  background: var(--ui-grey)
    url('@/assets/images/background-additional-info.webp') bottom no-repeat;
  border-radius: 30px;

  // Тут мы лезем в html, который зарендерили через v-html и меняем стили для дефолтных тегов
  &:deep {
    @include media('<tablet') {
      padding: 20px;
    }

    h3 {
      font-size: 16px;
      text-align: left !important;
    }

    ul {
      padding-left: 0;
      list-style-type: none;

      li {
        padding-bottom: 10px;
      }
    }
  }
}
</style>
